/* eslint-disable */
export default {
  _man_outline: 'man_outline',
  _title: 'title',
  _box_sternum: 'box_sternum',
  _box_spine: 'box_spine',
  _box_face: 'box_face',
  _box_skull: 'box_skull',
  _box_tibia: 'box_tibia',
  _box_patella: 'box_patella',
  _box_tarsals: 'box_tarsals',
  _box_pelvis: 'box_pelvis',
  _box_fibula: 'box_fibula',
  _box_metatarsals: 'box_metatarsals',
  _box_ribs: 'box_ribs',
  _box_femur: 'box_femur',
  _box_foot: 'box_foot',
  _box_scapula: 'box_scapula',
  _assemble_button: 'assemble_button',
  _label_button: 'label_button',
  _box_clavicle: 'box_clavicle',
  _box_humerus: 'box_humerus',
  _box_radius: 'box_radius',
  _box_ulna: 'box_ulna',
  _box_carpals: 'box_carpals',
  _ribs: 'ribs',
  _ribs_m: 'ribs_m',
  _box_hand: 'box_hand',
  _box_metacarpals: 'box_metacarpals',
  _spine: 'spine',
  _word_bg: 'word_bg',
  _scapula: 'scapula',
  _right_tibia: 'right_tibia',
  _left_femur: 'left_femur',
  _left_femur_m: 'left_femur_m',
  _right_femur: 'right_femur',
  _spine_m: 'spine_m',
  _right_femur_m: 'right_femur_m',
  _clavicle: 'clavicle',
  _scapula_m: 'scapula_m',
  _clavicle_m: 'clavicle_m',
  _skull: 'skull',
  _pelvis: 'pelvis',
  _left_radius: 'left_radius',
  _pelvis_m: 'pelvis_m',
  _skull_m: 'skull_m',
  _left_foot: 'left_foot',
  _eyes_green: 'eyes_green',
  _eyes_red: 'eyes_red',
  _right_tibia_m: 'right_tibia_m',
  _left_tibia: 'left_tibia',
  _left_tibia_m: 'left_tibia_m',
  _right_fibula: 'right_fibula',
  _right_fibula_m: 'right_fibula_m',
  _left_fibula: 'left_fibula',
  _right_hand: 'right_hand',
  _right_hand_m: 'right_hand_m',
  _left_fibula_m: 'left_fibula_m',
  _left_humerus: 'left_humerus',
  _left_humerus_m: 'left_humerus_m',
  _left_ulna: 'left_ulna',
  _right_humerus: 'right_humerus',
  _right_humerus_m: 'right_humerus_m',
  _left_hand: 'left_hand',
  _left_hand_m: 'left_hand_m',
  _left_ulna_m: 'left_ulna_m',
  _left_patella: 'left_patella',
  _right_patella: 'right_patella',
  _right_ulna: 'right_ulna',
  _right_ulna_m: 'right_ulna_m',
  _left_radius_m: 'left_radius_m',
  _right_radius: 'right_radius',
  _right_radius_m: 'right_radius_m',
  _face: 'face',
  _face_m: 'face_m',
  _sternum: 'sternum',
  _left_foot_m: 'left_foot_m',
  _right_foot: 'right_foot',
  _sternum_m: 'sternum_m',
  _right_foot_m: 'right_foot_m',
  _left_patella_m: 'left_patella_m',
  _right_patella_m: 'right_patella_m',
}